// extracted by mini-css-extract-plugin
export default {"napsaLog-header":"Header_napsaLog-header__MgprJ","napsaLog-header-item":"Header_napsaLog-header-item__OhLnj"};